/**
 * index.js
 *
 * Main project entry point. Import all the initial scaffolding files here.
 *
 */

// Project-wide JS
import 'babel-polyfill'; // required by React & es6 scripts to work on IE11
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import 'whatwg-fetch';
import '../components/components';
import '../sections/sections';
import '../styleguide/styleguide';
